import { createContext } from "react";

export const studentDataContext = createContext()